import { RootState } from "../../reducers";

export const useRMRSelector = (state: RootState): boolean =>
  state.clientScreen.useRMR;

export const selectedClientDocumentsSelector = (state: RootState): string[] =>
  state.clientScreen.selectedDocuments;
